(ns app.zap-vault.vault.view
  (:require [app.zap-vault.event :as app-event]
            [app.zap-vault.sub :as app-sub]
            [app.zap-vault.vault.event :as event]
            [app.zap-vault.vault.sub :as sub]
            [common.localization :as loc]
            [common.util :as cu]
            [re-frame.core :as rf]
            [ui.components.button.view :as button]
            [ui.components.layout.header :as header]
            [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
            [ui.components.radix-ui.tooltip.view :as tooltip]
            [ui.components.rich-text.tiptap :as tiptap]
            [ui.components.text.view :as text]
            [ui.util :as uu]))

(defn navbar
  []
  (let [vault-config @(rf/subscribe [::app-sub/vault-config])
        {:keys [vault-config/vault-logo]} vault-config
        vault-details @(rf/subscribe [::app-sub/vault-details])
        {:keys [vault-name vault-description]} vault-details]
    [header/header
     {:class "bg-base-light border border-b-1 border-solid border-base-light-border-paler"}
     [header/left-align
      {:class "w-[125px] max-w-[125px]"}
      [:img
       {:src   vault-logo
        :class "max-h-[25px] flex justify-self-start"}]]
     [header/center-align
      [text/h1
       {}
       vault-name
       (when-not (cu/blank-value? vault-description)
         [tooltip/view
          [:i.fa.fa-info-circle]
          [:div
           {:class "[&_.ProseMirror]:py-0 [&_.ProseMirror]:border-0 [&_.ProseMirror]:bg-transparent [&_.ProseMirror]:text-base-light"}
           [tiptap/viewer
            {:value (str vault-description)
             :styles {:padding 0}}]]])]]
     [header/right-align
      {:class "w-[125px] max-w-[125px]"}
      [dropdown-menu/view
       {:trigger [:i.fas.fa-bars]
        :items   [{:value      :logout
                   :label      (loc/tr :logout)
                   :icon-class "fa fa-arrow-left-from-bracket"
                   :on-click   (fn [_]
                                 (rf/dispatch [::app-event/logout]))}]}]]]))

(defn expand-icon
  []
  [button/sm-secondary-hollow
   {:class    "bg-base-light px-3"
    :on-click (fn [_]
                (rf/dispatch [::event/set-collapsed? false]))}
   [:i.fa.fa-arrow-right-from-line]])

(defn header-with-collapse-icon
  []
  [:div
   {:class (uu/cm "flex flex-0 flex-row gap-1 align-items-center text-n-2xs font-semi uppercase p-2")}
   [:div
    {:class "flex flex-auto"}
    (loc/tr :documents)]
   [button/square-secondary-open
    {:on-click (fn [_]
                 (rf/dispatch [::event/set-collapsed? true]))}
    [:i.fa.fa-arrow-left-from-line]]])

(defn toolbar
  []
  (let [collapsed? @(rf/subscribe [::sub/collapsed?])
        selected-file-id @(rf/subscribe [::sub/selected-file-id])]
    [:div
     {:class "flex-0 flex flex-row p-1 bg-base-regular border border-1 border-solid border-base-regular-border-paler"}
     [header/left-align
      {}
      (when collapsed?
        [expand-icon])]
     [header/center-align]
     [header/right-align
      {}
      [button/sm-secondary-hollow
       {:class    "bg-base-light"
        :on-click (fn [_]
                    (js/console.log "Download " selected-file-id)
                    (rf/dispatch [::event/download selected-file-id]))}
       (loc/tr :download)]]]))

(defn pdf-viewer
  [selected-file]
  [:iframe
   {:width  "100%"
    :height "100%"
    :src    (str "/js/pdfjs/web/viewer.html"
                 "?showOpenFileButton=false"
                 "&file=/zap-vault/api/download?file-id="
                 (:id selected-file))}])

(defn download-only
  [selected-file]
  [:div
   {:class "max-w-[400px] w-[400px] mt-10 p-10 border border-solid border-primary-light-border
   flex flex-col align-items-center
   bg-base-light"}
   [:i
    {:class "text-3xl fa fa-file-arrow-down"}]
   [text/h2-custom
    {:class "text-align-center"}
    (loc/tr :this-document-can-only-be-downloaded)]
   [text/info-text-xs
    {:class "text-align-center"}
    (loc/tr :download-only-info-pre-link)]
   [button/primary-open
    {:on-click (fn [_]
                 (js/console.log "Download " (:id selected-file))
                 (rf/dispatch [::event/download (:id selected-file)]))}
    (loc/tr :download-only-info-link)]])

(defn file-view
  []
  (let [selected-file @(rf/subscribe [::sub/selected-file])
        pdf? @(rf/subscribe [::sub/pdf-viewable?])]
    [:div
     {:class "flex-auto flex flex-col align-items-center"}
     (if pdf?
       [pdf-viewer selected-file]
       [download-only selected-file])]))

(defn sidebar
  []
  (let [collapsed? @(rf/subscribe [::sub/collapsed?])
        files @(rf/subscribe [::app-sub/sorted-documents])
        selected-file-id @(rf/subscribe [::sub/selected-file-id])]
    (when-not collapsed?
      [:div
       {:class "flex flex-col max-w-[300px] h-full overflow-y-auto bg-base-light min-h-0"}
       [header-with-collapse-icon]
       (->> files
            (map (fn [{:keys [id title description filename]}]
                   ^{:key (str "file-" id)}
                   [:div
                    {:class    (uu/cm "flex-0 flex flex-col p-2 m-1 cursor-pointer"
                                      (when (= id selected-file-id)
                                        "bg-base-regular")
                                      "hover:bg-base-regular")
                     :on-click (fn [_]
                                 (rf/dispatch [::event/select-file id]))}
                    [text/h3
                     {}
                     (or title filename)]
                    (when (and (= id selected-file-id)
                               (not (cu/blank-value? description)))
                      [:div
                       {:class "[&_.ProseMirror]:text-n-2xs [&_.ProseMirror]:border-0 [&_.ProseMirror]:bg-transparent"}
                       [tiptap/viewer
                        {:value description
                         :styles {:background "transparent"
                                  :border "none"
                                  :padding "0"}}]])]))
            (doall))])))

(defn content
  []
  [:div
   {:class "flex-auto flex flex-col overflow-y-auto min-h-0 gap-0"}
   [toolbar]
   [file-view]])

(defn view
  []
  [:div
   {:class "flex-auto flex flex-col gap-0"}
   [navbar]
   [:div
    {:class "flex-auto flex flex-row gap-0 min-h-0"}
    [sidebar]
    [content]]])
